import React from 'react'
import { Box, Tab, Tabs } from "@mui/material";
import stringUtils from "../../../utils/string_utils"
import commonColorUtils from "../../../utils/common_colors";
import CommonTextWithRoundedShape from '../../../components/CommonTextWithRoundedShape';

const TaskAllocationTabs = ({ activeTabValue, handleOnChangeTabs, commonCount }) => {
    const styleOfTab = {
        // width: '238px',
        minWidth: 'auto',
        marginX: 1,
        paddingX: 2, 
        fontFamily: 'Inter, Arial, sans-serif',
        color: commonColorUtils.primaryGrey600,
        fontWeight: 600,
        margin: '6px 4px',
        fontSize: '14px',
        textTransform: "none",
        '&.Mui-selected': {
            color: commonColorUtils.primaryMainBlue,  // Color when tab is selected
        },
    }
    return (
        <>
            <Tabs value={activeTabValue} onChange={handleOnChangeTabs} variant="scrollable"  sx={{width: 'fit-content',  }} TabIndicatorProps={{
                style: {
                    backgroundColor: commonColorUtils.primaryMainBlue,  // Underline color when the tab is selected
                },
            }}>
                <Tab label={<Box display="flex" alignItems="center">
                    {stringUtils.unassignedTasks}
                    <CommonTextWithRoundedShape text={commonCount?.unAssignedCount} />
                </Box>
                } sx={styleOfTab} />
                <Tab label={<Box display="flex" alignItems="center">
                    {stringUtils.assignedTasks}
                    <CommonTextWithRoundedShape text={commonCount?.assignedCount} />
                </Box>} sx={styleOfTab} />
                <Tab label={<Box display="flex" alignItems="center">
                    {stringUtils.completedTasks}
                    <CommonTextWithRoundedShape text={commonCount?.completedCount} />
                </Box>} sx={styleOfTab} />
            </Tabs>
        </>
    )
}
export default TaskAllocationTabs